// wp-icons — Extras (14)
// Additional icons matching lucide-react geometry.
import { createWpIcon } from './createIcon.js';

export const BellOff = createWpIcon('BellOff', [
  ['path', { d: 'M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5', key: 'a' }],
  ['path', { d: 'M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7', key: 'b' }],
  ['path', { d: 'M10.3 21a1.94 1.94 0 0 0 3.4 0', key: 'c' }],
  ['line', { x1: 2, x2: 22, y1: 2, y2: 22, key: 'd' }],
]);

export const FolderInput = createWpIcon('FolderInput', [
  ['path', { d: 'M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2', key: 'a' }],
  ['path', { d: 'M2 13h10', key: 'b' }],
  ['path', { d: 'm9 16 3-3-3-3', key: 'c' }],
]);

export const GraduationCap = createWpIcon('GraduationCap', [
  ['path', { d: 'M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z', key: 'a' }],
  ['path', { d: 'M22 10v6', key: 'b' }],
  ['path', { d: 'M6 12.5V16a6 3 0 0 0 12 0v-3.5', key: 'c' }],
]);

export const KeyRound = createWpIcon('KeyRound', [
  ['path', { d: 'M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z', key: 'a' }],
  ['circle', { cx: 16.5, cy: 7.5, r: 0.5, fill: 'currentColor', key: 'b' }],
]);

export const LineChart = createWpIcon('LineChart', [
  ['path', { d: 'M3 3v16a2 2 0 0 0 2 2h16', key: 'a' }],
  ['path', { d: 'm19 9-5 5-4-4-3 3', key: 'b' }],
]);

export const Link = createWpIcon('Link', [
  ['path', { d: 'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71', key: 'a' }],
  ['path', { d: 'M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71', key: 'b' }],
]);

export const Palmtree = createWpIcon('Palmtree', [
  ['path', { d: 'M13 8H7a4 4 0 0 0-4 4 7 7 0 0 1 4-2 4 4 0 0 0-4 4 10 10 0 0 1 6-3 8 8 0 0 0 4 6 5 5 0 0 0 2-3.5', key: 'a' }],
  ['path', { d: 'M13 8a8 8 0 0 1 8 8 7 7 0 0 0-4-2 4 4 0 0 1 3 4 8 8 0 0 0-5-3', key: 'b' }],
  ['path', { d: 'M13 8V2', key: 'c' }],
  ['path', { d: 'M13 22c.04-1.33 1.1-2 1.1-2', key: 'd' }],
]);

export const Percent = createWpIcon('Percent', [
  ['line', { x1: 19, x2: 5, y1: 5, y2: 19, key: 'a' }],
  ['circle', { cx: 6.5, cy: 6.5, r: 2.5, key: 'b' }],
  ['circle', { cx: 17.5, cy: 17.5, r: 2.5, key: 'c' }],
]);

export const SkipForward = createWpIcon('SkipForward', [
  ['polygon', { points: '5 4 15 12 5 20 5 4', key: 'a' }],
  ['line', { x1: 19, x2: 19, y1: 5, y2: 19, key: 'b' }],
]);

export const Star = createWpIcon('Star', [
  ['polygon', { points: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2', key: 'a' }],
]);

export const Thermometer = createWpIcon('Thermometer', [
  ['path', { d: 'M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z', key: 'a' }],
]);

export const UserCircle = createWpIcon('UserCircle', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['circle', { cx: 12, cy: 10, r: 3, key: 'b' }],
  ['path', { d: 'M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662', key: 'c' }],
]);

export const UserCog = createWpIcon('UserCog', [
  ['circle', { cx: 18, cy: 15, r: 3, key: 'a' }],
  ['circle', { cx: 9, cy: 7, r: 4, key: 'b' }],
  ['path', { d: 'M10 15H6a4 4 0 0 0-4 4v2', key: 'c' }],
  ['path', { d: 'm21.7 16.4-.9-.3', key: 'd' }],
  ['path', { d: 'm15.2 13.9-.9-.3', key: 'e' }],
  ['path', { d: 'm16.6 18.7.3-.9', key: 'f' }],
  ['path', { d: 'm19.1 12.2.3-.9', key: 'g' }],
  ['path', { d: 'm19.6 18.7-.4-1', key: 'h' }],
  ['path', { d: 'm16.8 12.3-.4-1', key: 'i' }],
  ['path', { d: 'm14.3 16.6 1-.4', key: 'j' }],
  ['path', { d: 'm20.7 13.8 1-.4', key: 'k' }],
]);

export const Wand2 = createWpIcon('Wand2', [
  ['path', { d: 'm21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72', key: 'a' }],
  ['path', { d: 'm14 7 3 3', key: 'b' }],
  ['path', { d: 'M5 6v4', key: 'c' }],
  ['path', { d: 'M19 14v4', key: 'd' }],
  ['path', { d: 'M10 2v2', key: 'e' }],
  ['path', { d: 'M7 8H3', key: 'f' }],
  ['path', { d: 'M21 16h-4', key: 'g' }],
  ['path', { d: 'M11 3H9', key: 'h' }],
]);
